import { useFormatPrice } from '@packages/shared/src/hooks/useFormatPrice/useFormatPrice';
import {
  getIntegerPriceValueByTargetType,
  type PriceTargetTypes,
} from '../../utils/formatPrice/getPriceValueByTargetType';

export const usePriceFormatter = (targetType: PriceTargetTypes) => {
  const { formatPrice } = useFormatPrice();

  return (price: Parameters<typeof formatPrice>[0], currency: Parameters<typeof formatPrice>[1]) =>
    formatPrice(getIntegerPriceValueByTargetType(price, targetType), currency);
};
